import script from "./RecadoDaEquipe.vue?vue&type=script&setup=true&lang=js"
export * from "./RecadoDaEquipe.vue?vue&type=script&setup=true&lang=js"

import "./RecadoDaEquipe.vue?vue&type=style&index=0&id=02ca081a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ca081a"]])

export default __exports__